import React from "react";
import { Link } from "react-router-dom";
import Logo from "../images/logo.webp";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

const FooterSection = () => {
	const currentYear = new Date().getFullYear();
	return (
		<footer className="bg-[#1C1B1C] text-white font-jost">
			<div
				className="w-[90%] mx-auto py-10 md:py-16
        grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6"
			>
				{/* Brand & About Us */}
				<div className="flex flex-col gap-4">
					<div className="logo h-14 w-14 bg-black rounded-full overflow-hidden">
						<Link to="/">
							<img src={Logo} alt="Witty Nails Logo" className="w-full" />
						</Link>
					</div>
					<p className="text-sm text-gray-300 pr-4 leading-relaxed">
						Welcome to Witty Nails! We provide premium, handcrafted nail tips and accessories designed to help you express your unique style with confidence and elegance.
					</p>
				</div>

				{/* Quick Links */}
				<div>
					<h4 className="font-semibold text-lg mb-4 text-[#FFB7CF]">Quick Links</h4>
					<ul className="text-sm flex flex-col gap-3 text-gray-300">
						<li>
							<Link to="/" className="hover:text-white transition-colors">Home</Link>
						</li>
						<li>
							<Link to="/#products-section" className="hover:text-white transition-colors">Products</Link>
						</li>
						<li>
							<Link to="/edit-profile" className="hover:text-white transition-colors">Profile</Link>
						</li>
						<li>
							<Link to="/cart" className="hover:text-white transition-colors">Cart</Link>
						</li>
					</ul>
				</div>

				{/* Legal */}
				<div>
					<h4 className="font-semibold text-lg mb-4 text-[#FFB7CF]">Legal</h4>
					<ul className="text-sm flex flex-col gap-3 text-gray-300">
						<li>
							<Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
						</li>
						<li>
							<Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
						</li>
					</ul>
				</div>

				{/* Contact & Socials */}
				<div className="flex flex-col gap-4">
					<h4 className="font-semibold text-lg text-[#FFB7CF]">Contact Us</h4>
					<p className="text-sm text-gray-300">Houston, TX, USA.</p>
					<p className="text-sm text-gray-300">
						<a href="mailto:info@wittynailtip.com" className="hover:text-white transition-colors">info@wittynailtip.com</a>
					</p>
					<p className="text-sm text-gray-300">
						<a href="tel:+18326774026" className="hover:text-white transition-colors">+1 (832) 677-4026</a>
					</p>
					
					<div className="mt-4 flex gap-5">
						<a href="#" className="text-gray-400 hover:text-white transition-colors">
							<FaFacebook size={20} />
						</a>
						<a href="#" className="text-gray-400 hover:text-white transition-colors">
							<FaTwitter size={20} />
						</a>
						<a 
							target="_blank"
							rel="noreferrer"
							href="https://www.instagram.com/wittynailtips?igsh=MW12anV0dmE2NXR3Yg=="
							className="text-gray-400 hover:text-white transition-colors"
						>
							<FaInstagram size={20} />
						</a>
					</div>
				</div>
			</div>

			<div className="w-full h-px bg-gray-800" />
			<div>
				<p className="text-center text-xs md:text-sm py-6 text-gray-500">
					&copy; {currentYear} Witty Nails. All Rights Reserved.
				</p>
			</div>
		</footer>
	);
};

export default FooterSection;
